'use es6';

import http from 'hub-http/clients/apiClient';
import { HUBSPOT_VIDEO_CRM_OBJECT_TYPE } from './constants';
export function fetchCrmVideoObjectsByIds(crmObjectIds) {
  return http.post('crm-search/search', {
    data: {
      count: crmObjectIds.length,
      filterGroups: [{
        filters: [{
          operator: 'IN',
          property: 'hs_object_id',
          values: crmObjectIds
        }]
      }],
      objectTypeId: HUBSPOT_VIDEO_CRM_OBJECT_TYPE,
      requestOptions: {
        properties: ['hs_title']
      }
    }
  });
}